// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pla {
  max-width: 44rem;
}
.pla__list {
  list-style: none;
  padding: 0;
  margin: 1.5rem 0;
}
.pla__list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--border);
}
.pla__list code {
  overflow-wrap: anywhere;
}
.pla__add {
  margin: 1.5rem 0;
}
.pla__add label {
  display: block;
  margin-bottom: 0.5rem;
}
.pla__add > div {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.pla__add input {
  min-width: 0;
  flex: 1;
  padding: 0.6rem;
  font: inherit;
  border: 1px solid var(--border);
  border-radius: var(--r-data);
  background: var(--surface);
  color: var(--text);
}
.pla__add input:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}
`, "",{"version":3,"sources":["webpack://./src/pages/plataforma/PlataformaAvisos.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;EACZ,OAAO;EACP,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B","sourcesContent":[".pla {\n  max-width: 44rem;\n}\n.pla__list {\n  list-style: none;\n  padding: 0;\n  margin: 1.5rem 0;\n}\n.pla__list li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid var(--border);\n}\n.pla__list code {\n  overflow-wrap: anywhere;\n}\n.pla__add {\n  margin: 1.5rem 0;\n}\n.pla__add label {\n  display: block;\n  margin-bottom: 0.5rem;\n}\n.pla__add > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.pla__add input {\n  min-width: 0;\n  flex: 1;\n  padding: 0.6rem;\n  font: inherit;\n  border: 1px solid var(--border);\n  border-radius: var(--r-data);\n  background: var(--surface);\n  color: var(--text);\n}\n.pla__add input:focus-visible {\n  outline: none;\n  box-shadow: var(--focus-ring);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
